import { useState } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const Wrapper = styled.div`
  color: ${({ color }) => themeGet(`colors.${color}`)};
  border-color: ${({ borderColor }) => themeGet(`colors.${borderColor}`)};
  border: 1px solid;
  border-radius: 8px;
  display: flex;
  justify-content: space-around;
  font-size: 9px;
  font-family: 'Montserrat', sans-serif;
`;

const StatWrapper = styled.div`
  padding: 5px 0;
  display: flex;
  align-items: center;
`;

const TileStatsComponent = ({ tileStats, tileId }) => {
  const [currentColor, setCurrentColor] = useState('black.80');

  return (
    <Wrapper
      color={currentColor}
      borderColor={currentColor}
      onMouseEnter={() => setCurrentColor('black.60')}
      onMouseLeave={() => setCurrentColor('black.80')}
      onMouseDown={() => setCurrentColor('black.100')}
      onMouseUp={() => setCurrentColor('black.80')}
      className={'stat_action js-open-tile-stats-modal'}
      data-tile-id={tileId}
      data-href={`/client_admin/tiles/${tileId}/tile_stats`}
    >
      <StatWrapper>
        <i className="fa-regular fa-user-group fa-lg" color={currentColor}></i>
        &nbsp;{tileStats.uniqueViews}
      </StatWrapper>

      <StatWrapper>
        <i className="fa-regular fa-eye fa-lg" color={currentColor}></i>
        &nbsp;{tileStats.views}
      </StatWrapper>

      <StatWrapper>
        <i className="fa-solid fa-check fa-lg" color={currentColor}></i>
        &nbsp;{tileStats.completions}
      </StatWrapper>
    </Wrapper>
  );
};

export default TileStatsComponent;
